import Search from "../../search/Search";
import SearchApi from "../../../api/SearchApi";

const CLASS_MAPPER = {
    '낮음' : 'rank-badge-blue',
    '중간' : '',
    '높음' : 'rank-badge-red'
}

const SearchAmountTable = ({ tmpSlot, isLoading }) => {
    const list = tmpSlot[6] === '-' ? [] : JSON.parse(tmpSlot[6].replaceAll("'", '"'));
    return (
        <table className="sortable">
            <colgroup>
                <col width="" />
                <col width="" />
                <col width="" />
                <col width="" />
                <col width="" />
            </colgroup>
            <thead>
                <th className="sorttable_nosort">키워드</th>
                <th>PC검색량</th>
                <th>모바일검색량</th>
                <th>총검색량</th>
                <th>경쟁강도</th>
            </thead>
            <tbody>
                {list.map(item => (
                    <tr key={item.relKeyword}>
                        <td>{item.relKeyword}</td>
                        <td>{item.monthlyPcQcCnt}</td>
                        <td>{item.monthlyMobileQcCnt}</td>
                        <td>{item.monthlyPcQcCnt + item.monthlyMobileQcCnt}</td>
                        <td><span className={`rank-badge ${CLASS_MAPPER[item.compIdx]}`}>{item.compIdx}</span></td>
                    </tr>
                ))}
                {list.length === 0 && (
                    isLoading
                    ? <tr>
                        <td colspan="5" className="rank-loading-overlay">
                            <div className="loading-spinner" style={{ margin: 'auto' }}></div>
                            <div className="loading-message">
                                <span>키워드 조회 중입니다. 잠시만 기다려 주세요.</span>
                            </div>
                        </td>
                    </tr>
                    : <tr>
                        <td colspan="5">
                            <div className="results-empty">
                                <p>검색 결과가 없습니다.</p>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

const SearchAmount = () => {
    return (
        <Search
            type={'searchAmount'} 
            api={SearchApi.searchAmount}
            useKeyword={false} 
            targetPlaceholder={'검색어를 입력하세요'}
            customTable={SearchAmountTable}
            waitingTime={4000}
        />
    )
}

const RelateKeywords = () => {
    return (
        <Search
            type={'relateKeywords'} 
            api={SearchApi.relateKeywords}
            useKeyword={false} 
            targetPlaceholder={'검색어를 입력하세요'}
            customTable={SearchAmountTable}
            waitingTime={4000}
        />
    )
}


export { SearchAmount, RelateKeywords }